import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/api";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-brand-sand-dark py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <p className="text-center text-[11px] font-mono uppercase tracking-[0.25em] text-brand-terracotta font-semibold">What clients say</p>
        <h2 className="mt-3 text-center font-display text-3xl sm:text-4xl font-black tracking-tight text-brand-navy-dark">
          Straight from the people Frank has moved
        </h2>
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure key={t.name} data-testid={`testimonial-${i}`} className="rounded-2xl border border-brand-border-sand bg-white p-7 sm:p-8 shadow-sm transition-shadow hover:shadow-md">
              <Quote className="h-6 w-6 text-brand-gold" />
              <div className="mt-3 flex gap-1 text-brand-gold" aria-label="5 stars">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-4 text-base leading-relaxed text-brand-slate">{t.quote}</blockquote>
              <figcaption className="mt-5 text-sm font-bold text-brand-navy-dark">
                {t.name} <span className="font-normal text-brand-slate/70">· {t.where}</span>
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="mt-8 text-center text-xs text-brand-slate/70">
          More about Frank at{" "}
          <a data-testid="testimonials-me-link" href="https://yourrealtorfrank.me" target="_blank" rel="noopener noreferrer" className="font-bold text-brand-navy hover:text-brand-red transition-colors">
            yourrealtorfrank.me
          </a>
        </p>
      </div>
    </section>
  );
}
